import { UiVaultConfig } from 'src/@types/vaults';
import { Warning } from '@drift-labs/icons';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { FeeChangeMessageContent } from './FeeChanges';
import Tag from '../primitives/Tag/Tag';
import dayjs from 'dayjs';
import VariantTag from 'src/components/Tags/VariantTag';

export const VaultTags = (props: {
	uiVaultConfig: UiVaultConfig;
	numOfVaultSnapshots: number;
	excludeName?: boolean;
}) => {
	const isNew = props.uiVaultConfig.isNew(props.numOfVaultSnapshots);
	const isHighRisk = props.uiVaultConfig.isHighRisk;

	const isDeprecating = props.uiVaultConfig.isDeprecating;
	const isDeprecated = props.uiVaultConfig.isDeprecated;

	const hasFeeChangesToWarnAbout =
		props.uiVaultConfig.feeChangesToAlert?.length > 0;

	return (
		<div className="flex flex-col items-start justify-center gap-y-xs">
			<div className="flex flex-wrap items-center gap-xs">
				{!props.excludeName && (
					<Tag className="bg-button-secondary-bg-hover text-text-default">
						{props.uiVaultConfig.vaultManager.name}
					</Tag>
				)}
				{isNew && <VariantTag variant="new" />}
				{isHighRisk && (
					<Tag
						className="bg-warn-orange-secondary-bg text-star-yellow"
						rightIcon={Warning}
					>
						High Risk
					</Tag>
				)}
				{isDeprecating && (
					<Tooltip
						decoration="none"
						content={`This vault is ${
							isDeprecated ? 'deprecated' : 'soon to be deprecated'
						} and ${
							isDeprecated ? 'stopped trading' : 'will stop trading'
						} on ${dayjs(props.uiVaultConfig.deprecationDateTs).format(
							'MMM D, YYYY'
						)}. Please withdraw your funds.`}
					>
						<Tag
							className="bg-negative-red-secondary-bg text-negative-red"
							rightIcon={Warning}
						>
							{isDeprecated ? 'Deprecated' : 'Deprecating'}
						</Tag>
					</Tooltip>
				)}
				{hasFeeChangesToWarnAbout && (
					<Tooltip
						decoration="none"
						content={
							<FeeChangeMessageContent vaultConfig={props.uiVaultConfig} />
						}
					>
						<Tag
							className="bg-warn-orange-secondary-bg text-star-yellow"
							rightIcon={Warning}
						>
							Fee Update
						</Tag>
					</Tooltip>
				)}
			</div>
		</div>
	);
};
